import {IconsAccessibility, IconsType} from "../constants/constants";
import {Accessibility} from "../models/Accessibility";
import {AccessibilityUnit} from "../models/AccessibilityUnits";
import {AccessibilityInfo, RelatedModel} from "../models/AccessibilityInfo";
import {AccessibilityUnitLevel} from "../models/AccessibilityLevel";
import {A11yStandardType} from "../models/A11yStandard";
import {Question} from "../models/Question";
import {getMeasurementsByAttribute, replaceText} from "./measurement";

export const filterAccessibilityInfoByDisabilities = (
  accessibilityInfo: AccessibilityInfo[],
  disabilityTypes: string[],
  questionsList: Question[]
): Array<{answerText: string, titleText: string | null, iconsAccessibility: (IconsType | undefined)[], relatedModel: string}> => {
  try {
    if (disabilityTypes?.length > 0) {
      const filteredIconsAccessibility = IconsAccessibility.filter(({ disabilityType }) => (
        disabilityTypes.includes(disabilityType)
      ))
      accessibilityInfo = accessibilityInfo.filter(({ question }) => {
        const foundQuestion = questionsList.find((i) => i.id === question)
        if (foundQuestion) {
          return filteredIconsAccessibility.some(({type})=> foundQuestion.question_type.includes(type))
        }
        return true
      })
    }

    const result: Array<{answerText: string, titleText: string | null, iconsAccessibility: (IconsType | undefined)[], relatedModel: string}> = []
    accessibilityInfo.forEach(({answer, question}) => {
      const foundQuestion = questionsList.find((i) => i.id === question)
      if (foundQuestion) {
        result.push({
          answerText: foundQuestion[`answer_text_${answer}` as keyof Omit<Question, 'created_at' | 'updated_at' | 'question_type'>],
          titleText: foundQuestion.related_model === RelatedModel.buildingAreaGeneralInfo ? foundQuestion.unit_type : null,
          iconsAccessibility: foundQuestion.question_type.map((type) => IconsAccessibility.find((icon) => type === icon.type)),
          relatedModel: foundQuestion.related_model
        })
      }
    })
    return result
  } catch (e) {
    console.error(e)
    return []
  }
};

export const replaceAccessibilitiesTitle = (accessibilities: Accessibility[], units: any, a11yStandard?: A11yStandardType) => {
  // the standard is what holds the measurements the titles below interpolate
  const measurements = getMeasurementsByAttribute(a11yStandard ? [a11yStandard] : [])

  return accessibilities.map((accessibility) => {
    const foundUnit = units.find((i: any) => i.id === accessibility.accessibility_unit)

    return {
      ...accessibility,
      attribute_title: replaceText(
        accessibility.attribute_title,
        accessibility.item_title,
        foundUnit?.title,
        a11yStandard?.title,
        measurements[accessibility.attribute]
      )
    }
  })
}

export const replaceNestedAccessibilities = (accessibilities: Accessibility[], accessibleUnits: AccessibilityUnit[]) => {
  return accessibilities?.map((acc) => {
    let accessibilityUnitId = acc.accessibility_unit
    const relatedUnit = accessibleUnits
      .find((unit) => unit.id === acc.accessibility_unit)
    if (relatedUnit && relatedUnit.related_to.length > 0) {
      accessibilityUnitId = relatedUnit.related_to[0]
    }
    return {
      ...acc,
      accessibility_unit: accessibilityUnitId
    }
  })
}

export const getAccessibilityUnitLevelNumber = (unitLevel: AccessibilityUnitLevel[] | undefined, units: AccessibilityUnit[]) => {
  if (unitLevel) {
    const filterAccessibleUnit = unitLevel.filter((i) => {
      if (i.accessibility_unit) {
        const findUnit = units.find((u) => u.id === i.accessibility_unit)
        return findUnit ? findUnit.is_accessible_unit : false
      }
      return true
    })

    return filterAccessibleUnit.reduce(
      (accum, item) => accum + item.number_of_units,
      0
    );
  }
  return 0;
}
